module.exports = "/static/assets/83bea64a7a91dd3527f999f19ad18762.png";